import Date from 'components/Date';
import WaitingDots from 'components/WaitingDots';
import {Email} from 'models/Email';
import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {starEmail} from "store/actions/Emails";
import {RootState} from 'store/store';
import { useOfficeTranslation } from "i18n/OfficeTranslation";

interface Props {
    email: Email;
    compact?: boolean;
    threadSize?: number;
    hideTo?: boolean;
    hideLabels?: boolean;
    hideDirection?: boolean;
    selectable?: boolean;
    selected?: boolean;
    onToggleSelect?: (email: Email) => void;
    onStarChange?: (email: Email) => void;
}


interface Actions {
    starEmail: (e: Email, b: any) => Promise<Email>;
}


const EmailRowInbox: React.FC<Props & Actions> = ({
                                                      email,
                                                      compact,
                                                      hideDirection,
                                                      hideLabels,
                                                      hideTo,
                                                      selectable,
                                                      selected,
                                                      onToggleSelect,
                                                      onStarChange,
                                                      threadSize,
                                                      starEmail
                                                  }) => {
    const { t } = useOfficeTranslation();

    if (hideLabels === undefined) {
        hideLabels = false
    }
    if (hideDirection === undefined) {
        hideDirection = false
    }
    if (hideTo === undefined) {
        hideTo = false
    }
    if (email === undefined) {
        return <WaitingDots/>
    }

    const star = () => {
        const starred = !email.starred;
        starEmail(email, {starred}).then(updated => {
            onStarChange?.(updated);
        }).catch(() => undefined);
    }

    if (compact) return <li className="invoice-email-row">
        <i className="mdi mdi-email-outline invoice-email-channel" aria-hidden="true" />
        <Link to={"/conversation/" + email.id} className="invoice-email-content">
            <strong>{email.subject}</strong>
            <span>{t("common.to")} {email.recipient}</span>
            <small><Date date={email.GetDate()} />{email.HasFailed() && <span className="text-danger ms-2">{t("email.emailRowInbox.failed")}</span>}</small>
        </Link>
        <button type="button" className="btn invoice-email-star" onClick={star}
            aria-label={t("email.emailRowInbox.starSubject", {subject: email.subject})} aria-pressed={email.starred}>
            <i className={email.starred ? "bx bxs-star text-warning" : "bx bx-star"} aria-hidden="true" />
        </button>
    </li>;

    return (
        <li key={email.id}
            className={`red-hover mail-row ${selectable ? "mail-row-selectable" : ""} ${!email.IsRead() && "text-bold"}`}>
            {selectable &&
                <button
                    key={email.id}
                    type="button"
                    className="mail-select-toggle"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        onToggleSelect && onToggleSelect(email)
                    }}
                    aria-label={t("email.emailRowInbox.selectSubject", {subject: email.subject})}
                >
                    {selected ?
                        <span className="bx bx-check-square"/> : <span className="bx bx-square"/>}

                </button>
            }
            <Link to={"/conversation/" + email.id} className="mail-row-link">
                <div className="col-mail col-mail-1">
                    {!hideTo &&
                        <>
                            {email.direction === "in" ?
                                <>
                                    <i className="title" title={email.sender}>{!hideDirection && t("common.from") + " "}
                                        {email.sender_name === "" ? email.sender : email.sender_name}
                                        {threadSize && threadSize > 1 && <span className="badge bg-primary rounded-pill"
                                                                               style={{
                                                                                   marginLeft: "5px",
                                                                                   fontStyle: "normal"
                                                                               }}>{threadSize}</span>}
                                    </i>
                                </>
                                :
                                <>
                                    <i className="title"
                                       title={email.recipient}>{!hideDirection && t("common.to") + " "}{email.recipient.split(" ")[0]}</i>
                                </>
                            }
                        </>
                    }
                    {
                        email.starred ?
                            <span onClick={(e) => {
                                e.preventDefault()
                                star()
                            }} className={"star-toggle text-warning bx bxs-star"}/>
                            :
                            <span onClick={(e) => {
                                e.preventDefault()
                                star()
                            }} className={"star-toggle bx bx-star"}/>
                    }
                    <br/>
                </div>
                <div className="col-mail col-mail-2">
                    <div className="subject" style={{marginTop: "5px"}}>
                        {email.subject}{" "}
                        {(!hideLabels && email.reference.includes("invoice")) &&
                            <Link to={"/invoice/" + email.reference.replace('invoice_', '')}>
                                <span className="badge bg-success me-1 font-size-12 me-2 mb-3">
                                    {t("common.invoice")}
                                </span>
                            </Link>
                        }
                        {(!hideLabels && email.reference.includes("ticket")) &&
                            <span className="badge bg-danger me-1 font-size-12 me-2 mb-3">
                                {t("common.ticket")}
                            </span>
                        }
                        {email.direction === "out" && email.HasFailed() &&
                            <span className="badge bg-danger me-1 font-size-12 me-2 mb-3">
                                {t("email.emailRowInbox.failed")}
                            </span>
                        }
                        <span className="teaser" style={{color: "grey"}}>
                            - {email.body.replaceAll("<br />", " ").replace(/(\r\n|\n|\r)/gm, "").replaceAll(/<blockquote (.*?)>(.*?)<\/blockquote>/img, "").replaceAll(/<style(.*?)>(.*?)<\/style>/img, "").replaceAll(/<(.*?)>/img, " ").replaceAll(/\s{2,}/img, " ")}
                        </span>
                    </div>
                    <div className="date">
                        <Date date={email.GetDate()}/>
                    </div>
                </div>
            </Link>
        </li>
    );
}

const mapStateToProps = (state: RootState) => {
    return {
        customers: state.Customers,
        emails: state.Emails
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators({starEmail}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailRowInbox);
